import { render, staticRenderFns } from "./claims-form.vue?vue&type=template&id=f35dfc9a&"
import script from "./claims-form.vue?vue&type=script&lang=js&"
export * from "./claims-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports